module.exports = __webpack_public_path__ + "static/img/qingyeLogo.6519c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingyeLogo.png
// module id = tRaq
// module chunks = 1